module.exports = require("@mui/icons-material/ExpandMore");